module.exports = __webpack_public_path__ + "static/media/congrats.2df80a8b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/congrats.svg
// module id = 1410
// module chunks = 0